import { render, staticRenderFns } from "./FeatureInfo.vue?vue&type=template&id=82b625d6&scoped=true&"
import script from "./FeatureInfo.vue?vue&type=script&lang=js&"
export * from "./FeatureInfo.vue?vue&type=script&lang=js&"
import style0 from "./FeatureInfo.vue?vue&type=style&index=0&id=82b625d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b625d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
